import { requireContractAccess } from '@/lib/route-guards';
import { registryItemQueryOptions } from '@/queryOptions';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/properties/$propertyId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    version: search.version as string | undefined,
  }),
  context: ({ params }) => ({
    getBreadcrumbData: () => ({
      id: params.propertyId,
      translationKey: null,
    }),
  }),
  beforeLoad: ({ params, context, search }) => {
    requireContractAccess(context);
    return context.queryClient.ensureQueryData(registryItemQueryOptions(params.propertyId, search.version));
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Property Details - OPAZ E-Service Portal',
        },
      ],
    };
  },
});
